module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou9-f96270683a932dd8ca8de6dd5412ab46.jpg";